export const bounceInUpCss = ({
  transitionDistance = 3000,
  transitionContainerId = '#synchronisedEnterContainer',
  includeIdAnimationMapping = true,
}) => {
  const idAnimationMapping = includeIdAnimationMapping
    ? `
      ${transitionContainerId} {
        animation-name: bounceInUp;
      }
    `
    : '';
  return `
  @keyframes bounceInUp {
    from,
    60%,
    75%,
    90%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    from {
      opacity: 0;
      transform: translate3d(0, -${transitionDistance}px, 0) scaleY(1.5);
    }
    60% {
      opacity: 1;
      transform: translate3d(0, 20px, 0) scaleY(0.9);
    }
    75% {
      transform: translate3d(0, -10px, 0) scaleY(0.95);
    }
    90% {
      transform: translate3d(0, 5px, 0) scaleY(0.985);
    }
    to {
      transform: translate3d(0, 0, 0);
    }
  }
  ${idAnimationMapping}
`;
};

export const bounceInDownCss = ({
  transitionDistance = 3000,
  transitionContainerId = '#synchronisedEnterContainer',
}) => `
  @keyframes bounceInDown {
    from,
    60%,
    75%,
    90%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    0% {
      opacity: 0;
      transform: translate3d(0, ${transitionDistance}px, 0) scaleY(1.5);
    }
    60% {
      opacity: 1;
      transform: translate3d(0, -25px, 0) scaleY(0.9);
    }
    75% {
      transform: translate3d(0, 10px, 0) scaleY(0.95);
    }
    90% {
      transform: translate3d(0, -5px, 0) scaleY(0.985);
    }
    to {
      transform: translate3d(0, 0, 0);
    }
  }

  ${transitionContainerId} {
    animation-name: bounceInDown;
  }
`;

export const bounceOutUpCss = ({ transitionDistance = 3000 }) => `
  @keyframes bounceOutUp {
    20% {
      transform: translate3d(0, -10px, 0) scaleY(0.985);
    }
    40%,
    45% {
      opacity: 1;
      transform: translate3d(0, 20px, 0) scaleY(0.9);
    }
    to {
      opacity: 0;
      transform: translate3d(0, -${transitionDistance}px, 0) scaleY(1.5);
    }
  }
`;

export const customExitBounceOutUpCss = ({
  transitionDistance = 3000,
  transitionContainerId = '#customExitContainer',
}) => `
  @keyframes customExitFadeOut {
    20% {
      transform: translate3d(0, -10px, 0) scaleY(0.985);
    }
    40%,
    45% {
      opacity: 1;
      transform: translate3d(0, 20px, 0) scaleY(0.9);
    }
    to {
      opacity: 0;
      transform: translate3d(0, -${transitionDistance}px, 0) scaleY(1.5);
    }
  }
  ${transitionContainerId} {
    animation-name: bounceOutUp;
  }
`;

export const bounceOutDownCss = ({ transitionDistance = 3000 }) => `
  @keyframes bounceOutDown {
    20% {
      transform: translate3d(0, 10px, 0) scaleY(0.985);
    }
    40%,
    45% {
      opacity: 1;
      transform: translate3d(0, -20px, 0) scaleY(0.9);
    }
    to {
      opacity: 0;
      transform: translate3d(0, ${transitionDistance}px, 0) scaleY(1.5);
    }
  }
`;

export const forwardDirectionBounceCSS = `
  .bounce-appointment-booking-direction-enter-active {
    animation-name: bounceInUp;
  }
  .bounce-appointment-booking-direction-exit-active {
    animation-name: bounceOutUp;
  }
  .bounce-cpc-card-direction-enter-active {
    animation-name: bounceInUp;
  }
  .bounce-cpc-card-direction-exit-active {
    animation-name: bounceOutUp;
  }
  .bounce-direction-enter-active {
    animation-name: bounceInUp;
  }
  .bounce-direction-exit-active {
    animation-name: bounceOutUp;
  }
`;

export const backwardDirectionBounceCSS = `
  .bounce-appointment-booking-direction-enter-active {
    animation-name: bounceInDown;
  }
  .bounce-appointment-booking-direction-exit-active {
    animation-name: bounceOutDown;
  }
  .bounce-cpc-card-direction-enter-active {
    animation-name: bounceInDown;
  }
  .bounce-cpc-card-direction-exit-active {
    animation-name: bounceOutDown;
  }
  .bounce-direction-enter-active {
    animation-name: bounceInDown;
  }
  .bounce-direction-exit-active {
    animation-name: bounceOutDown;
  }
`;
